import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSavedCartListComponent } from './custom-saved-cart-list/saved-cart-list.component';
import { I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbModule, DIALOG_TYPE, LayoutConfig, SortingModule, SpinnerModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomCartDetailsModalComponent } from '../custom-cart-details-modal/custom-cart-details-modal.component';
import { CustomCartDetailsRestoreModalComponent } from '../custom-cart-details-restore-modal/custom-cart-details-restore-modal.component';
import { CustomSortingComponent } from '@shared/custom-sorting/custom-sorting.component';
import { CustomPaginationComponent } from '@shared/custom-pagination/custom-pagination.component';
import { ModalDateComponent } from '../custom-order-history/modal-date/modal-date.component';
import { EmptyListComponent } from '@shared/empty-list/empty-list.component';

export const CustomSavedCartsModalConfig: LayoutConfig = {
  launch: {
    DELETE_SAVED_CART: {
      inline: true,
      component: CustomCartDetailsModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CUSTOM_SAVED_CART: {
      inline: true,
      component: CustomCartDetailsRestoreModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    MODAL_DATE2: {
      inline: true,
      component: ModalDateComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};

@NgModule({
  declarations: [CustomSavedCartListComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterLink,
    UrlModule,
    SpinnerModule,
    BreadcrumbModule,
    SharedModule,
    SortingModule,
    CustomSortingComponent,
    CustomPaginationComponent,
    EmptyListComponent
  ],
  providers: [provideDefaultConfig(CustomSavedCartsModalConfig)],
})
export class CustomSavedCartsModule {}
